import { Box, CircularProgress } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';

const SignIn = lazy(() => import('pages/sign-in'));

const Loader = (): JSX.Element => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress />
  </Box>
);

export const Route = createFileRoute('/_authenticated/_main/me')({
  component: MyAccountWrapper,
});

function MyAccountWrapper(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <SignIn />
    </Suspense>
  );
}
